module.exports = __webpack_public_path__ + "static/media/verified-order_16.248e9630.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/verified-order_16.svg
// module id = 918
// module chunks = 0